import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuoteOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 86,
	height: 58,
	viewBox: "0 0 86 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: "quote-mark-svg quote-mark-open",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M85.7285 57.25H46.9785V26.3105C46.9785 21.5475 47.8665 17.5312 49.6426 14.2617C51.4186 10.9518 53.7598 8.28776 56.666 6.26953C59.5723 4.2513 62.8822 2.79818 66.5957 1.91016C70.3092 1.02214 74.1035 0.578125 77.9785 0.578125V18.5C77.1712 18.5404 76.3034 18.6816 75.375 18.9238C74.487 19.166 73.6595 19.5697 72.8926 20.1348C72.166 20.6999 71.5404 21.487 71.0156 22.4961C70.5312 23.4648 70.2891 24.7161 70.2891 26.25H85.7285V57.25ZM39.2285 57.25H0.478516V26.3105C0.478516 21.5475 1.36654 17.5312 3.14258 14.2617C4.91862 10.9518 7.25977 8.28776 10.166 6.26953C13.0723 4.2513 16.3822 2.79818 20.0957 1.91016C23.8092 1.02214 27.6035 0.578125 31.4785 0.578125V18.5C30.6712 18.5404 29.8034 18.6816 28.875 18.9238C27.987 19.166 27.1595 19.5697 26.3926 20.1348C25.666 20.6999 25.0404 21.487 24.5156 22.4961C24.0312 23.4648 23.7891 24.7161 23.7891 26.25H39.2285V57.25Z",
		fill: "#FF5789"
	})
});
export default SvgQuoteOpen;
